import { render, staticRenderFns } from "./UserViewInfo.vue?vue&type=template&id=45be5fc4"
import script from "./UserViewInfo.vue?vue&type=script&lang=js"
export * from "./UserViewInfo.vue?vue&type=script&lang=js"
import style0 from "./UserViewInfo.vue?vue&type=style&index=0&id=45be5fc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports